const newItems = {
  new_status: {
    pt: 'Novo status',
    en: 'New status',
    es: 'Nuevo status',
  },
  new_user: {
    pt: 'Novo Usuário',
    en: 'New User',
    es: 'Nuevo Usuario',
  },
  addUserButton: {
    pt: ' Novo Usuário',
    en: ' New User',
    es: ' Nuevo Usuario',
  },
  new_designer: {
    pt: 'Novo projetista',
    en: 'New designer',
    es: 'Nuevo diseñador',
  },
  new_status_group: {
    pt: 'Novo grupo de status',
    en: 'New group of status',
    es: 'Nuevo grupo de status',
  },
  new_report: {
    pt: 'Novo relatório',
    en: 'New report',
    es: 'Nuevo informe',
  },
  new_service: {
    pt: 'Novo serviço',
    en: 'New service',
    es: 'Nuevo servicio',
  },
  new_indicators: {
    pt: 'Novo indicador',
    en: 'New indicator',
    es: 'Nuevo indicador',
  },
  new_object_type: {
    pt: 'Novo tipo de objeto',
    en: 'New type of object',
    es: 'Nuevo tipo de objeto',
  },
  new_file: {
    pt: 'Novo arquivo',
    en: 'New file',
    es: 'Nuevo archivo',
  },
  new_enterprise: {
    pt: 'Novo empreendimento',
    en: 'New master project',
    es: 'Nuevo emprendimiento',
  },
  new_field: {
    pt: 'Novo campo',
    en: 'New field',
    es: 'Nuevo campo',
  },
  add_customizable_column: {
    pt: 'Novo campo personalizável',
    en: 'New customizable field',
    es: 'Nuevo campo personalizable',
  },
  new_measurer_type: {
    pt: 'Novo tipo de medidor',
    en: 'New measurer type',
    es: 'Nuevo tipo de medidor',
  },
  new_source: {
    pt: 'Nova fonte',
    en: 'New source',
    es: 'Nueva fuente',
  },
  new_record: {
    pt: 'Novo registro',
    en: 'New record',
    es: 'Nuevo registro',
  },
  new_service_indicators: {
    pt: 'Novos indicadores do serviço',
    en: 'New project indicators',
    es: 'Nuevos indicadores de proyecto',
  },
  new_customizable_column: {
    pt: 'Nova coluna personalizável',
    en: 'New customizable column',
    es: 'Nueva columna personalizable',
  },
  new_password: {
    pt: 'Nova senha',
    en: 'New password',
    es: 'Nueva contraseña',
  },
  add_form_of_service: {
    pt: 'Nova forma de atendimento',
    en: 'New type of attention',
    es: 'Nueva forma de atención',
  },
  new_form_of_service: {
    pt: 'Nova forma de atendimento',
    en: 'New type of attention',
    es: 'Nueva forma de atención',
  },
  new_company: {
    pt: 'Nova empresa',
    en: 'New company',
    es: 'Nueva compañía',
  },
  new_project: {
    pt: 'Novo projeto',
    en: 'New project',
    es: 'Nuevo proyecto',
  },
  add_terms_of_use: {
    pt: 'Adicionar termo de uso',
    en: 'Add terms of use',
    es: 'Agregar términos de uso',
  },
  // Requirement items translations
  requirement_details: {
    pt: 'Detalhes do Requisito',
    en: 'Requirement Details',
    es: 'Detalles del Requisito',
  },
  items: {
    pt: 'itens',
    en: 'items',
    es: 'ítems',
  },
  add_item: {
    pt: 'Adicionar Item',
    en: 'Add Item',
    es: 'Agregar Ítem',
  },
  no_description: {
    pt: 'Sem descrição',
    en: 'No description',
    es: 'Sin descripción',
  },
  due_date: {
    pt: 'Data de Vencimento',
    en: 'Due Date',
    es: 'Fecha de Vencimiento',
  },
  confirm_delete_item: {
    pt: 'Deseja realmente excluir este item?',
    en: 'Do you really want to delete this item?',
    es: '¿Realmente desea eliminar este elemento?',
  },
  edit_requirement_item: {
    pt: 'Editar Item do Requisito',
    en: 'Edit Requirement Item',
    es: 'Editar Ítem del Requisito',
  },
  new_requirement_item: {
    pt: 'Novo Item do Requisito',
    en: 'New Requirement Item',
    es: 'Nuevo Ítem del Requisito',
  },
  item_title: {
    pt: 'Título do Item',
    en: 'Item Title',
    es: 'Título del Ítem',
  },
  title_required: {
    pt: 'Título é obrigatório',
    en: 'Title is required',
    es: 'El título es obligatorio',
  },
  priority: {
    pt: 'Prioridade',
    en: 'Priority',
    es: 'Prioridad',
  },
  priority_low: {
    pt: 'Baixa',
    en: 'Low',
    es: 'Baja',
  },
  priority_medium: {
    pt: 'Média',
    en: 'Medium',
    es: 'Media',
  },
  priority_high: {
    pt: 'Alta',
    en: 'High',
    es: 'Alta',
  },
  status_pending: {
    pt: 'Pendente',
    en: 'Pending',
    es: 'Pendiente',
  },
  status_in_progress: {
    pt: 'Em Andamento',
    en: 'In Progress',
    es: 'En Progreso',
  },
  status_completed: {
    pt: 'Concluído',
    en: 'Completed',
    es: 'Completado',
  },
  status_blocked: {
    pt: 'Bloqueado',
    en: 'Blocked',
    es: 'Bloqueado',
  },
  item_updated_success: {
    pt: 'Item atualizado com sucesso',
    en: 'Item updated successfully',
    es: 'Ítem actualizado exitosamente',
  },
  item_added_success: {
    pt: 'Item adicionado com sucesso',
    en: 'Item added successfully',
    es: 'Ítem agregado exitosamente',
  },
  item_deleted_success: {
    pt: 'Item removido com sucesso',
    en: 'Item removed successfully',
    es: 'Ítem eliminado exitosamente',
  },
  error_saving_item: {
    pt: 'Erro ao salvar item',
    en: 'Error saving item',
    es: 'Error al guardar ítem',
  },
  error_deleting_item: {
    pt: 'Erro ao remover item',
    en: 'Error removing item',
    es: 'Error al eliminar ítem',
  },
  minimum_one_item_required: {
    pt: 'Deve haver pelo menos um item',
    en: 'There must be at least one item',
    es: 'Debe haber al menos un elemento',
  },
  select_responsible: {
    pt: 'Selecionar responsável',
    en: 'Select responsible',
    es: 'Seleccionar responsable',
  },
};

export default newItems;
